// Tipos de busca para autocomplete
export const SEARCH_TYPES = {
	// GenericAutocomplete
	CLIENTE_DEMANDA: 'cliente-demanda',
	FILTRO_DEMANDA: 'filtro-demanda',
	CLIENTE: 'cliente',
	FAMILIA: 'familia',
	SUB_FAMILIA: 'sub_familia',
	MODELO_PRODUTO: 'modelo_produto',
	PRODUTO: 'produto',
	GRUPO_RECURSO: 'grupo_recurso',
	MEMBRO: 'membro',

	// GenericAutocompleteWithData
	CIDADE: 'cidade',
	MARCA: 'marca',
	MODELO: 'modelo',
	VERSAO: 'versao',

	// GenericAutocompleteInfiniteScroll
	ROTEIRO_PRODUCAO: 'roteiro-producao',
} as const;

// Campos de filtro para cada tipo
export const FILTER_FIELDS = {
	[SEARCH_TYPES.FAMILIA]: 'nome_familia',
	[SEARCH_TYPES.SUB_FAMILIA]: 'nome_sub_familia',
	[SEARCH_TYPES.MODELO_PRODUTO]: 'nome_modelo',
	[SEARCH_TYPES.MEMBRO]: 'nome_membro',
	[SEARCH_TYPES.CLIENTE]: 'razao_social',
	[SEARCH_TYPES.MARCA]: 'nome_marca',
	[SEARCH_TYPES.MODELO]: 'nome_modelo',
	[SEARCH_TYPES.VERSAO]: 'nome_versao',
} as const;

// Configurações padrão
export const AUTOCOMPLETE_CONFIG = {
	DEFAULT_LIMIT: 5,
	MAX_RESULTS_PAGE: 20,
	SEARCH_DELAY: 250,
	INFINITE_SCROLL_DELAY: 350,
} as const;
